

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/underconstruction/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/8.DlR950mM.js","_app/immutable/chunks/Z8InAVTp.js","_app/immutable/chunks/xihTtKlq.js"];
export const stylesheets = [];
export const fonts = [];
